import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import LearningPaths from "./pages/LearningPaths";
import Rooms from "./pages/Rooms";
import RoomDetail from "./pages/RoomDetail";
import Leaderboard from "./pages/Leaderboard";
import Profile from "./pages/Profile";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import Certificate from "./pages/Certificate";
import Teams from "./pages/Teams";
import AcceptInvite from "./pages/AcceptInvite";
import MagicLinkVerify from "./pages/MagicLinkVerify";
import AuthCallback from "./components/AuthCallback";

// AppRouter handles the session_id detection synchronously during render
// This prevents race conditions with the AuthProvider's checkAuth
function AppRouter() {
  const location = useLocation();

  // Capture incoming referral code (?ref=CODE) and stash it for later.
  // We do this synchronously so it is available to AuthModal on first render.
  const searchParams = new URLSearchParams(location.search);
  const incomingRef = searchParams.get('ref');
  if (incomingRef && typeof window !== 'undefined') {
    try {
      window.localStorage.setItem('pendingReferralCode', incomingRef.trim());
    } catch (err) {
      // localStorage unavailable (incognito/strict mode) — referral won't
      // be picked up by AuthModal, but nothing else breaks.
      console.debug('[app] stash referral failed:', err?.message);
    }
  }

  // Check URL fragment (not query params) for session_id SYNCHRONOUSLY
  // This must happen during render, NOT in useEffect (which runs after first render)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/paths" element={<LearningPaths />} />
      <Route path="/rooms" element={<Rooms />} />
      <Route path="/room/:roomId" element={<RoomDetail />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/certificate/:roomId" element={<Certificate />} />
      <Route path="/teams" element={<Teams />} />
      <Route path="/teams/accept/:token" element={<AcceptInvite />} />
      <Route path="/auth/magic" element={<MagicLinkVerify />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
